<template>
  <base-table-wrapper>
    <template #top-buttons>
      <router-link tag="button" :to="{ name: 'EXCMUserDataStatusCreate' }" class="float-right mb-1 btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
    </template>
    <template #filtering>
      <div class="text-right">
        <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.userdatastatus_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="userdatastatus_search_collapse" class="mt-2">
          <UserDataSalesOpportunityFiltering url="e_x_c_m_user_data_statuses" @getPage="getPage($event)"></UserDataSalesOpportunityFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <Loader v-if="isLoading" size="lg"></Loader>
      <template v-else>
        <div v-if="items.length > 0">
          <table class="table table-sm table-striped table-hover">
            <thead>
            <tr>
              <th>{{$t('views.excmuserdatastatus.list.name')}}</th>
              <th>{{$t('views.excmuserdatastatus.list.description')}}</th>
              <th>{{$t('views.excmuserdatastatus.list.color')}}</th>
              <th colspan="2" />
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="item in items"
              :key="item['@id']">
              <td>
                {{ item['title'] }}
              </td>
              <td>
                {{ item['description'] }}
              </td>
              <td>
                <span v-b-tooltip.hover :title="item.color" :style="'color: ' + item.color" class="h6 mt-0 mb-0"><i class="fa fa-circle mr-2"></i></span>
              </td>
              <td>
                <b-dropdown class="float-right" variant="link" size="sm" right text="Right align">
                  <template #button-content>
                    <i class="fa fa-bars fa-lg"></i>
                  </template>
                  <b-dropdown-item @click="show(item['@id'])"><i class="fa fa-search mr-2"></i>{{$t('buttons.goto')}}</b-dropdown-item>
                  <b-dropdown-item @click="edit(item['@id'])"><i class="fa fa-edit mr-2"></i>{{$t('buttons.edit')}}</b-dropdown-item>
                  <b-dropdown-item v-if="item.state === 1" @click="archiveItem(item['@id'])"><i class="fa fa-edit mr-2"></i>{{$t('buttons.archive')}}</b-dropdown-item>
                  <b-dropdown-item v-if="item.state === 0" @click="unArchiveItem(item['@id'])"><i class="fa fa-edit mr-2"></i>{{$t('buttons.unArchive')}}</b-dropdown-item>
                  <b-dropdown-item @click="deleteItem(item['@id'])"><i class="fa fa-trash mr-2"></i>{{$t('buttons.delete')}}</b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
            </tbody>
          </table>
          <div v-if="view">
            <pagination
              :view="view"
              @getPage="getPage($event)"
            ></pagination>
          </div>
        </div>
        <p v-else>{{ $t('views.excmuserdatastatus.list.noStatus') }}</p>
      </template>
    </template>
  </base-table-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../Layout/Loader'
import addParamsToQuery from '@/utils/addParamsToQuery'
import Pagination from '../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper.vue'
import UserDataSalesOpportunityFiltering from '@/components/Dashboard/Views/excmuserdatasalesopportunity/components/UserDataSalesOpportunityFiltering.vue'
import { archive, unArchive } from '@/utils/archive'
import remove from '@/utils/remove'

export default {
  components: {
    BaseTableWrapper,
    UserDataSalesOpportunityFiltering,
    Loader,
    Pagination
  },
  computed: mapGetters({
    deletedItem: 'excmuserdatastatus/del/deleted',
    error: 'excmuserdatastatus/list/error',
    items: 'excmuserdatastatus/list/items',
    isLoading: 'excmuserdatastatus/list/isLoading',
    view: 'excmuserdatastatus/list/view'
  }),
  data () {
    return {
      searchParams: {
        state: 1
      }
    }
  },
  created () {
    let url = addParamsToQuery('e_x_c_m_user_data_statuses', this.searchParams)
    this.getPage(url)
  },
  methods: {
    ...mapActions({
      getPage: 'excmuserdatastatus/list/default'
    }),
    show (id) {
      this.$router.push({ name: 'EXCMUserDataStatusShow', params: { id: id } })
    },
    edit (id) {
      this.$router.push({ name: 'EXCMUserDataStatusUpdate', params: { id: id } })
    },
    archiveItem (id) {
      archive(id, () => { this.getPage(this.view['@id']) })
    },
    unArchiveItem (id) {
      unArchive(id, () => { this.getPage(this.view['@id']) })
    },
    deleteItem (id) {
      remove(id, () => { this.getPage(this.view['@id']) })
    }
  }
}
</script>
